import { useQuery } from '@tanstack/react-query';
import { servicesApi } from '../api/servicesApi';

/** GET /api/eraf/gateway/services — 활성/비활성 전체 서비스 목록 (페이징 없음, #621). */
export function useServicesQuery() {
  return useQuery({
    queryKey: ['gateway', 'services'],
    queryFn: () => servicesApi.list(),
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
}

/** GET /api/eraf/gateway/services/{id} — 타겟/upstream 포함 서비스 상세 (#621). */
export function useServiceDetailQuery(id: string | null) {
  return useQuery({
    queryKey: ['gateway', 'service', id],
    queryFn: () => servicesApi.get(id!),
    enabled: !!id,
    staleTime: 30_000,
  });
}
